import { defineModule, isFunction } from '../utils/helpers';

declare const show_cookie_banner: () => void | undefined;
declare const cmplz_set_category_as_body_class: () => void | undefined;
declare const cmplz_get_banner_status: () => string | undefined;
const body = document.querySelector('body');

const onBannerStatusChange = (event: Event) => {
  if (!body) return;

  const detail = (event as CustomEvent).detail;

  body.classList.toggle('cmplz-noscroll', detail !== 'dismissed');
};

const onCookieBannerLoaded = () => {
  if (!body) return;

  const bannerStatus = cmplz_get_banner_status();

  body.classList.toggle('cmplz-noscroll', bannerStatus !== 'dismissed');
};

export default defineModule(
  () => {
    try {
      if (isFunction(show_cookie_banner)) {
        show_cookie_banner();
      }
      if (isFunction(cmplz_set_category_as_body_class)) {
        cmplz_set_category_as_body_class();
      }
    } catch (err) {
      // console.error('Error initializing cookie functions:', err);
    }

    document.addEventListener('cmplz_banner_status', onBannerStatusChange);
    document.addEventListener(
      'cmplz_cookie_warning_loaded',
      onCookieBannerLoaded,
    );
  },
  () => {
    document.removeEventListener('cmplz_banner_status', onBannerStatusChange);
    document.removeEventListener(
      'cmplz_cookie_warning_loaded',
      onCookieBannerLoaded,
    );
  },
);